import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { CreateFillOutSession } from "@/features/FillOutWizard/CreateFillOutSession";
import { CreateFillOutSessionFormQuery } from "@/features/FillOutWizard/CreateFillOutSession/graphql";
import { zodRespondentTypeEnum } from "@/models/respondent";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session",
)({
  validateSearch: zodValidator(
    z.object({
      respondentType: zodRespondentTypeEnum,
      measuredQuestionnaireIds: z.array(z.string()),
    }),
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, measurementId, dossierId } = Route.useParams();
  const { respondentType, measuredQuestionnaireIds } = Route.useSearch();
  const { data } = useSuspenseQuery(CreateFillOutSessionFormQuery, {
    variables: { organizationKey, measurementId, measuredQuestionnaireIds, dossierId },
  });

  return (
    <CreateFillOutSession
      measurement={data.organization.measurement}
      labTestResults={data.dossier.labTestResults.nodes}
      respondentType={respondentType}
      measuredQuestionnaireIds={measuredQuestionnaireIds}
    />
  );
}
